// K-Dental Sales Web — entry point. Boots React 18, TanStack Query, and the
// TanStack Router.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.js';
import { createQueryClient } from './lib/query.js';
import { startOutboxProcessor } from './lib/outbox-processor.js';
import { initPwa } from './lib/pwa.js';
import './index.css';

const queryClient = createQueryClient();

// Drain any orders queued offline as soon as connectivity allows.
startOutboxProcessor();

// Register the service worker (installability + offline + update prompt).
void initPwa();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
